// src/api/axiosInstance.js
import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// Store userId and token from AuthenticatedUserInfoContext in axiosInstance
export const setAxiosAuth = (userId: string | null, token: string | null) => {
  if (userId) {
    localStorage.setItem('axiosUserId', userId);
  } else {
    localStorage.removeItem('axiosUserId');
  }
  if (token) {
    localStorage.setItem('axiosToken', token);
  } else {
    localStorage.removeItem('axiosToken');
  }
};

// ✅ Request interceptor to attach JWT token from localStorage
api.interceptors.request.use(config => {
  const token = localStorage.getItem('axiosToken');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Optionally attach userId as a custom header if needed
  const userId = localStorage.getItem('axiosUserId');
  if (userId && config.headers) {
    config.headers['X-User-Id'] = userId;
  }
  return config;
});

// ✅ Optional: Global response error interceptor (for logging or auth errors)
api.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      console.error('Network or CORS error:', error.message);
    } else if (error.response.status === 401) {
      console.warn('Unauthorized - maybe token expired.');
      console.warn('Error details:', error.response.data);
      
      // Only clear auth data if we're sure the token is invalid
      // Don't auto-logout on every 401 - let the components handle it
      const token = localStorage.getItem('token');
      if (token && error.response.data?.message?.includes('expired')) {
        console.warn('Token is expired, clearing auth data');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Only reload if we're on a protected route
        if (window.location.pathname !== '/auth') {
          window.location.href = '/auth';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
